import React, { HTMLAttributes, ReactNode } from 'react';
import classNames from 'classnames';
import * as styles from './VisuallyHidden.module.scss';

type Props = {
  children?: ReactNode;
  component?: 'span' | 'div';
} & HTMLAttributes<HTMLElement>;

export const VisuallyHidden = ({
  children,
  component = 'span',
  className,
  ...rest
}: Props) =>
  React.createElement(
    component,
    { className: classNames(styles.VisuallyHidden, className), ...rest },
    children
  );
